




















































































import {Component, Vue, Watch} from 'vue-property-decorator';
import IconGroup from '../assets/icon-group.svg';
import IconClock from '../assets/icon-clock.svg';
import IconWaitTime from '../assets/icon-wait-time.svg';
import IconMessage from '../assets/icon-message.svg';
import moment from 'moment-timezone';
import {TicketStore} from '@/store/modules/ticket.store';
import {WebService} from '@/services/web.service';
import { OverlayShowTime } from '@/constants';
import WaitlistOverlay from '@/components/WaitlistOverlay.vue';
import BadgePicker from '@/components/BadgePicker.vue';
// @ is an alias to /src

@Component({
	components: {
		IconGroup,
		IconClock,
		IconWaitTime,
		IconMessage,
		'waitlist-overlay': WaitlistOverlay,
		'badge-picker': BadgePicker
	}
})
export default class Waitlist extends Vue {
	showWaitlistOverlay = false;
	selectedTicketId = '';

	showOverlay = false;
	overlayColor = 'green';
	overlayMessage = '';

	showError = false;
	errorMessage = '';

	showLoading = false;
	smsSentTo: string[] = [];

	showBadgePicker = false;
	forceUpdateEveryMinute = 0;
	forceUpdateEveryMinuteInterval = 0;

	get currentlyWaiting() {
		return TicketStore.currentlyWaiting;
	}

	get waitlist() {
		// tslint:disable-next-line
		this.forceUpdateEveryMinute;
		return TicketStore.waitlist.map((ticket) => {
			return {
				ticketId: ticket.ticketId,
				customer: {
					name: ticket.customer.name !== '' && ticket.customer.name !== null ? ticket.customer.name : 'anonymous',
					phone: ticket.customer.phone ? ticket.customer.phone : ''
				},
				partySize: ticket.partySize,
				quoted: (ticket.waitTime as number) / 60,
				waiting: Math.floor(moment.duration(moment().diff(moment.unix(ticket.openedDate))).asMinutes()),
				openedDate: ticket.openedDate,
				smsSent: this.smsSentTo.indexOf(ticket.customer.phone as string) !== -1
			};
		});
	}

	async resendSms(ticketId: string) {
		const ticket = TicketStore.byId(ticketId);
		if(ticket) {
			try {
				this.showLoading = true;
				await WebService.sendSms(ticket.ticketId, ticket.customer.phone as string);
				this.showLoading = false;
				this.overlayColor = 'blue';
				this.overlayMessage = `SMS Sent!`;
				this.showOverlay = true;
				this.smsSentTo.push(ticket.customer.phone as string);
				setTimeout(() => {
					this.showOverlay = false;
				}, OverlayShowTime);
			} catch(e) {
				this.showLoading = false;
				this.errorMessage = 'There was a problem sending the SMS';
				this.showError = true;
			}
		}

	}

	seat(ticketId: string) {
		this.selectedTicketId = ticketId;
		this.showBadgePicker = true;
	}

	async badgeSelected(badgeId: string) {
		try {
			this.showLoading = true;
			await WebService.seatWaitlist(this.selectedTicketId, badgeId);
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `Customer Seated!`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			console.log(e);
			this.errorMessage = 'There was a problem seating your waitlist spot';
			this.showError = true;
		}
	}

	edit(ticketId: string) {
		this.selectedTicketId = ticketId;
		this.showWaitlistOverlay = true;
	}

	close() {
		this.$emit('close');
	}

	mounted() {
		// This logic is here to force the computation of the waitlist items
		// so that the time ticks up. I'm running it every 10 seconds because
		// I feel like that's more that good enough without causing any perf hit
		this.forceUpdateEveryMinuteInterval = setInterval(() => {
			this.forceUpdateEveryMinute++;
		}, 10000);
	}

	destroyed() {
		clearInterval(this.forceUpdateEveryMinuteInterval);
	}
}
